import { useCallback } from "react";
import { Button } from "@/components/Buttons/index";
import styles from "@/styles/Video.module.scss";
import { useChatEventGAPush } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ChatSelect(_ref) {
  let {
    setChatDisplay,
    setIsChatSelected,
    play,
    isLive,
    state
  } = _ref;
  const handleStart = useCallback(() => {
    if (!play) return;
    if (isLive) state.updateResumePoint(0.1);else state.updateResumePoint(0);
  }, [play, isLive]);
  const {
    joinRoomEvent
  } = useChatEventGAPush();
  return /*#__PURE__*/_jsx("div", {
    className: styles.resume,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.buttons,
      children: [/*#__PURE__*/_jsx(Button, {
        fillMainColor: true,
        chatSelect: true,
        fontBold: true,
        onClick: () => {
          setChatDisplay(false);
          setIsChatSelected(true);
          handleStart();
        },
        children: "\u25B6\uFE0E\u518D\u751F\u3059\u308B"
      }), /*#__PURE__*/_jsx(Button, {
        fillWhiteColor: true,
        chatSelect: true,
        fontBold: true,
        onClick: () => {
          var _state$rooms;
          setChatDisplay(true);
          setIsChatSelected(true);
          handleStart();
          joinRoomEvent(state === null || state === void 0 || (_state$rooms = state.rooms) === null || _state$rooms === void 0 || (_state$rooms = _state$rooms[0]) === null || _state$rooms === void 0 ? void 0 : _state$rooms.roomId);
        },
        children: "\u25B6\uFE0E\u30C1\u30E3\u30C3\u30C8\u4ED8\u304D\u3067\u518D\u751F\u3059\u308B"
      })]
    })
  });
}